/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * ASSETS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CBRRouteDeleteMutation from './__mutation__/index.cbrroute.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationCBRRouteDelete, MutationCBRRouteDeleteResponse] = useMutation(CBRRouteDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationCBRRouteDeleteResponse.loading} onConfirm={() => MutationCBRRouteDelete({
      'variables': {
        'routeId': passOn?.routeId
      }
    }).then(i => {
      // Style Guide.
      toast(i?.data?.CBRRouteDelete?.message)

      // Execute refetch.
      refetch?.()

      // Report success.
      return onClose?.()
    }).catch(() =>
      // Style Guide.
      toast('Something went wrong please try after some time.'))} isLoading={MutationCBRRouteDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
